import { ThemeConfig, theme } from 'antd';
import { typography } from './typography';
import { tokens } from './tokens';

export const customTheme: ThemeConfig = {
  token: {
    // Seed token
    fontFamily: `'Open Sauce Two', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif`,

    fontFamilyCode: typography.fontFamilies.openSauce,
    fontSize: typography.body.sm.fontSize,
    colorBgBase: tokens.colors.primary.white,
    colorTextBase: tokens.colors.primary.black,
    colorPrimary: '#d9d9d9',
    colorSuccess: tokens.colors.supporting.green[600],
    colorWarning: tokens.colors.supporting.yellow[600],
    colorError: tokens.colors.supporting.red[600],

    // Map Tokens
    colorBgLayout: tokens.colors.primary.white,
    fontSizeHeading1: typography.heading.xl.fontSize,
    fontSizeHeading2: typography.heading.lg.fontSize,
    fontSizeHeading3: typography.heading.md.fontSize,
    fontSizeHeading4: typography.heading.sm.fontSize,
    lineHeightHeading1: typography.heading.xl.lineHeight,
    lineHeightHeading2: typography.heading.lg.lineHeight,
    lineHeightHeading3: typography.heading.md.lineHeight,
    lineHeightHeading4: typography.heading.sm.lineHeight,
    fontSizeXL: typography.body.xl.fontSize,
    fontSizeLG: typography.body.lg.fontSize,
    fontSizeSM: typography.body.sm.fontSize,
    lineHeightLG: typography.body.lg.lineHeight,
    lineHeightSM: typography.body.sm.lineHeight

    // Alias Tokens
  },

  algorithm: theme.compactAlgorithm,

  components: {
    Typography: {
      fontFamilyCode: typography.fontFamilies.openSauce
    },
    Button: {
      algorithm: true,
      borderRadius: 12,
      contentFontSize: typography.body.sm.fontSize,

      // Primary button (type="primary")
      colorPrimary: tokens.colors.brands.blue[400],
      colorPrimaryHover: tokens.colors.brands.blue[100],

      // Default button styling
      defaultBg: tokens.colors.brands.blue[600],
      defaultColor: tokens.colors.primary.white,

      // Disabled states
      colorBgContainerDisabled: '#f5f5f5',
      colorTextDisabled: '#999',
      borderColorDisabled: '#e0e0e0',

      // Sombras
      boxShadow: '0 2px 8px rgba(154, 33, 140, 0.15)'
    },

    Tree: {
      nodeSelectedBg: tokens.colors.brands.blue[100], // Color de fondo del nodo seleccionado
      nodeSelectedColor: tokens.colors.brands.blue[600], // Color del texto seleccionado
      directoryNodeSelectedBg: tokens.colors.brands.blue[600], // Fondo del directorio seleccionado
      directoryNodeSelectedColor: tokens.colors.primary.white, // Texto del directorio seleccionado
      nodeHoverBg: tokens.colors.brands.blue[600] // Color al hacer hover
    },

    Tabs: {
      itemActiveColor: '#667eea',
      itemHoverColor: '#475569',
      itemSelectedColor: '#667eea',
      inkBarColor: 'transparent',
      cardBg: 'white'
    }
  }
};
